import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Intent } from '../../@types/intent'
import { updateIntent } from '../../store/lead/leadSlice'
import { Progress } from '../../@types/progress'
import { useReportViewEvent } from '../../hooks'
import { reportTrackingEvent } from '../../tracking/thunks'
import { getCustomDimensionForIntent } from '../../tracking/tracking'

import './ReinforcementRentOutStep.scss'
import { ReinforcementStepIcon } from '../../components/icons/StepIcons/ReinforcementStepIcon'
import { Button } from '../../components/styled/CosmaButton/CosmaButton'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'

const tinyColor = require('tinycolor2')

interface RentOutReinforcementStepProps {
  goToNextStep: () => unknown
  goToPreviousStep: () => unknown
  progress: Progress
  displayBack: boolean
}

const headline = 'Folgende Vorteile verpasst du ohne Makler:'

export const RentOutReinforcementStep: FC<RentOutReinforcementStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'reinforcement' })
  const { config } = useSelector((state: ReduxState) => state)
  const { theme, integrationType } = config

  const dispatch = useDispatch()

  const goToNextStep = (intent: Intent) => {
    dispatch(updateIntent(intent))
    dispatch(
      reportTrackingEvent({
        label: 'reinforcement_submit',
        action: 'realtor-leadengine',
        category: 'residential',
        pageTitle: 'reinforcement',
        inputValue: getCustomDimensionForIntent(intent),
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: getCustomDimensionForIntent(intent),
        },
      })
    )
    props.goToNextStep()
  }

  return (
    <StepTemplate
      icon={<ReinforcementStepIcon />}
      headline={headline}
      displayNext={false}
      goToPreviousStep={props.goToPreviousStep}
      progress={props.progress}
      displayBack={props.displayBack}
      className='reinforcement-layer'
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <div className={`grid-item one-whole`}>
        <div className='grid-item one-whole'>
          <div className='details-holder one-half mr-auto status-holder justify-center'>
            <ul className='status-list list-check'>
              <li>
                <span className='status-primary-text header-text'>Qualifizierte Miet-Interessenten</span>
                <span className='status-secondary-text header-sub-text'>Bonitäre, zuverlässige und seriöse Mieter</span>
              </li>
              <li>
                <span className='status-primary-text'>Wenig Aufwand</span>
                <span className='status-secondary-text'>Spar dir Besichtigungstermine und Organisation</span>
              </li>
              <li>
                <span className='status-primary-text'>Optimaler Mietpreis</span>
                <span className='status-secondary-text'>Durch regionale Marktkenntnis</span>
              </li>
            </ul>
            <div className='status-summary palm-hide'>
              <p className='status-primary-text'>
                <i className='back-icon is24-icon-info1 align-middle' />
                Bitte beachte
              </p>
              <p className='status-secondary-text status-description'>
                Unsere Immobilienbewertung bietet lediglich eine erste Einschätzung. Erst ein Makler vor Ort kann den
                Wert und die optimale Miete exakt bestimmen.
              </p>
            </div>
          </div>
        </div>
        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center'>
          <Button
            data-testid='error-step-reload-page-button'
            onClick={() => goToNextStep(Intent.MAKLER_LET)}
            appearance='primary'
            className='palm-one-whole status-btn'
            primary={theme.primary}
            secondary={theme.secondary}
            textColor={
              (integrationType === IntegrationType.EXTERNAL && tinyColor(theme?.primary).isDark()) ||
              integrationType === IntegrationType.IMMOVERKAUF24
                ? '#FFFFFF'
                : theme.text
            }
            secondaryLight={theme.secondaryLight}
          >
            Zum unverbindlichen Maklervergleich
          </Button>
        </div>
        <div className='grid-item one-whole margin-top-m padding-horizontal-l align-center'>
          <a
            href='#/'
            onClick={() => goToNextStep(Intent.INDEPENDENT_LET)}
            style={{ color: integrationType === IntegrationType.IMMOVERKAUF24 ? '#2780ba' : '#2267e8' }}
          >
            Ich habe kein Interesse
          </a>
        </div>

        <div className='grid-item one-whole margin-top-xxl padding-horizontal-l align-center mr-auto status-mobile'>
          <div className='status-summary mr-auto'>
            <p className='status-primary-text'>
              <i className='back-icon is24-icon-info1 align-middle' />
              Bitte beachte
            </p>
            <p className='status-secondary-text status-description'>
              Unsere Immobilienbewertung bietet lediglich eine erste Einschätzung. Erst ein Makler vor Ort kann den Wert
              und die optimale Miete exakt bestimmen.
            </p>
          </div>
        </div>
      </div>
    </StepTemplate>
  )
}

export default RentOutReinforcementStep
